import React from 'react';
import { EndorsementCard } from './EndorsementCard';
import { useFadeInOnScroll } from '../hooks/useFadeInOnScroll';
import endorsements from '../data/endorsements.json';

import type { Endorsement } from './EndorsementCard';

export function EndorsementBand() {
  const { ref, style } = useFadeInOnScroll<HTMLElement>();

  return (
    <section
      ref={ref}
      className="endorsement-band"
      aria-labelledby="endorsement-title"
      style={style}
    >
      <h2 id="endorsement-title" className="section-eyebrow">
        Endorsed at the Highest Level
      </h2>
      <div className="endorsement-band__grid">
        {(endorsements as Endorsement[]).map((e, i) => (
          <EndorsementCard
            key={e.id}
            data={e}
            style={{ transitionDelay: `${i * 150}ms` }}
          />
        ))}
      </div>
    </section>
  );
}
